import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { SELECT_ACTIVITY_TYPES } from 'constants/stock-activity'
import { Form as FormComponent } from 'components/Form'
import { SearchProductInput } from 'components/SearchProductInput'
import { ApiErrors } from 'ui-components/ApiErrors'
import {
  TitleForm,
  InputForm,
  SelectForm,
} from 'components/Form/components'

export default function Form(props) {
  const {
    stockActivity,
    onCancel,
    onSave,
    responseError,
  } = props

  const [selectedType, setSelectedType] = useState(SELECT_ACTIVITY_TYPES[0])
  const [attributes, setAttributes] = useState({})

  useEffect(() => {
    setAttributes({ ...stockActivity.attributes })
  }, [stockActivity])

  const handleChange = (evt) => {
    const { name, value } = evt.target

    setAttributes({
      ...attributes,
      [name]: value,
    })
  }

  const handleChangeSelect = (evt) => {
    setSelectedType(evt)
  }

  const handlePrductSelection = (product) => {
    setAttributes({
      ...attributes,
      product_id: product.id,
    })
  }

  const handleSave = () => {
    onSave({
      ...attributes,
      activity_type: selectedType.value,
    })
  }

  return (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
    >
      <TitleForm>Registro de entrada/saída</TitleForm>
      <ApiErrors responseError={responseError} />

      <InputForm
        fullWidth
        label="Data"
        type="date"
        name="date"
        value={attributes.date}
        onChange={handleChange}
      />

      <SearchProductInput onSelect={handlePrductSelection} />

      <SelectForm
        options={SELECT_ACTIVITY_TYPES}
        value={selectedType}
        onChange={handleChangeSelect}
        label="Tipo"
        name="activity_type"
      />

      <InputForm
        fullWidth
        label="Quantidade"
        type="number"
        name="quantity"
        value={attributes.quantity}
        onChange={handleChange}
      />

      <InputForm
        fullWidth
        label="Descrição"
        type="text"
        name="description"
        value={attributes.description}
        onChange={handleChange}
      />

    </FormComponent>
  )
}

Form.propTypes = {
  stockActivity: PropTypes.objectOf(PropTypes.any).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  responseError: PropTypes.objectOf(PropTypes.any),
}

Form.defaultProps = {
  responseError: {},
}
